import React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import { useTranslation } from 'react-i18next';
import ActionItem from './ActionItem';
import useGlobal from '../util/Global';

const MenuListAction = ({ menuItems, buttonLabel = 'İŞLEM', buttonVariant = 'contained', menuItemEnable = true }) => {
    //const { t } = useGlobal();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div style={{ textAlign: 'center', display: menuItemEnable }}>
            <Button onClick={handleClick} size="small" variant={buttonVariant}>
                {buttonLabel}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {menuItems.map((item, index) => (
                    <ActionItem
                        key={index}
                        label={item.label}
                        icon={item.icon}
                        disabled={item?.menuEnable}
                        action={() => {
                            item.action();
                            handleClose();
                        }}
                    />
                ))}

            </Menu>
        </div>
    );
};

export default MenuListAction;
